export default __webpack_public_path__ + "static/shr-new-875a3a3bf2cd09c0f3ab04dd98e9ef0c.jpg";